import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/inputs/input';
import InputRadio from '@/components/ui/inputs/input-radio';
import { InputSelect } from '@/components/ui/inputs/input-select';
import { useForm, Controller } from 'react-hook-form';
import { addItemAddonService, updateItemAddonService, getByIdItemAddonService } from '@/services/ItemAddonServices';
import { getItemVariationService } from '@/services/ItemVariationServices';
import { getItemService } from '@/services/ItemServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import CommonModal from '@/components/ui/modals/CommonModal';

const AddEditItemAddonModel = ({ modelTitle, openModel, setOpenModel, getTableData, itemId, editDataId = '' }) => {
    const selectRef = useRef(null);
    const selectVariRef = useRef(null);
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);
    const [itemDataSource, setItemDataSource] = useState([]);
    const [itemAttributData, setItemAttributData] = useState('');
    const [itemDataOptionList, setItemOptionList] = useState([]);
    const [itemVariationOptionList, setItemVariationOptionList] = useState([]);
    const [itemStatus, setItemStatus] = useState(1);

    useEffect(() => {
        if (openModel && openModel != '') {
            formReset();
            getItemsData();
            if (editDataId && editDataId != '') {
                getDataById(editDataId);
            }
        }
    }, [openModel]);

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
            await setValue('status', '1');
            await setItemStatus(1);
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const handleChangeRadio = (event) => {
        if (event.target.name == 'status') {
            setValue('status', event.target.value);
            setItemStatus(event.target.value);
        }
    };

    const handleModelClose = () => {
        formReset();
        setOpenModel(false);
        document.body.style.overflowY = 'auto';
        getTableData();
    };

    const handleChangeItem = (name, value) => {
        setValue(name, value);
        setIsLoading(true);
        dispatch(
            getItemVariationService({
                search: '',
                page: 1,
                limit: 1000,
                extra_filter: { item_id: value },
            })
        )
            .then((res) => {
                var itemAttDataArr = res?.data?.data?.data;
                var itemAttOptionArray = [];
                itemAttDataArr.forEach((element) => {
                    itemAttOptionArray.push({
                        value: element?._id,
                        label: element?.name,
                    });
                });
                setItemVariationOptionList(itemAttOptionArray);
                if (itemAttDataArr.length > 0 && itemAttDataArr && itemAttDataArr[0] && itemAttDataArr[0]?.item_attribute_id && itemAttDataArr[0]?.item_attribute_id?.name) {
                    setItemAttributData(itemAttDataArr[0]?.item_attribute_id?.name);
                }

                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const getItemsData = () => {
        setIsLoading(true);
        dispatch(
            getItemService({
                search: '',
                page: 1,
                limit: 1000,
            })
        )
            .then((res) => {
                var itemDataArr = res?.data?.data?.data;
                var itemOptionArray = [];
                itemDataArr.forEach((element) => {
                    if (element?._id != itemId) {
                        itemOptionArray.push({
                            value: element?._id,
                            label: element?.name,
                        });
                    }
                });
                setItemOptionList(itemOptionArray);
                setItemDataSource(itemDataArr);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const getDataById = (editId) => {
        setIsLoading(true);
        dispatch(getByIdItemAddonService(editId))
            .then((res) => {
                var formData = res?.data?.data;
                for (const key in formData) {
                    if (key == 'addon_item_id') {
                        handleChangeItem('addon_item_id', formData[key]?._id);
                    } else if (key == 'addon_item_variation') {
                        setValue('addon_item_variation', formData[key]?._id);
                    } else if (formData.hasOwnProperty(key) && formData[key] != '') {
                        setValue(key, formData[key]);
                    } else {
                        setValue(key, '');
                    }
                }
                if (formData) {
                    setValue('status', formData.status);
                    setItemStatus(formData.status);
                }
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        data.item_id = itemId;
        var addEditService = '';
        if (editDataId && editDataId != '') {
            addEditService = updateItemAddonService(editDataId, data);
        } else {
            addEditService = addItemAddonService(data);
        }
        dispatch(addEditService)
            .then((res) => {
                formReset();
                setIsFormSumbmit(false);
                handleModelClose();
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <CommonModal modelTitle={modelTitle} openModel={openModel} handleModelClose={handleModelClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <Controller
                        control={control}
                        rules={{ required: true }}
                        name="addon_item_id"
                        render={({ field }) => (
                            <InputSelect
                                {...field}
                                labelStyleClassName="db-field-title required"
                                ref={selectRef}
                                id={'addon_item_id'}
                                labelText={'Addon Item'}
                                value={itemDataOptionList.find((data) => data.value == getValues('addon_item_id')) || null}
                                onChange={(e) => handleChangeItem('addon_item_id', e)}
                                options={itemDataOptionList}
                                errorType={errors?.addon_item_id?.type}
                            />
                        )}
                    />
                    {itemAttributData && itemAttributData != '' ? (
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="addon_item_variation"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    ref={selectVariRef}
                                    id={'addon_item_variation'}
                                    labelText={itemAttributData}
                                    value={itemVariationOptionList.find((data) => data.value == getValues('addon_item_variation')) || null}
                                    onChange={(e) => setValue('addon_item_variation', e)}
                                    options={itemVariationOptionList}
                                    errorType={errors?.addon_item_variation?.type}
                                />
                            )}
                        />
                    ) : (
                        <></>
                    )}
                    <div className="form-input-item">
                        <label className="db-field-title required" htmlFor="active">
                            {'Status'}
                        </label>
                        <div className="db-field-radio-group">
                            <InputRadio
                                id="active"
                                name="status"
                                labelText={'Active'}
                                value="1"
                                onChange={() => handleChangeRadio({ target: { name: 'status', value: 1 } })}
                                checked={itemStatus == '1' ? true : false}
                            />
                            <InputRadio
                                id="inactive"
                                name="status"
                                labelText={'Inactive'}
                                value="2"
                                onChange={() => handleChangeRadio({ target: { name: 'status', value: 2 } })}
                                checked={itemStatus == '2' ? true : false}
                            />
                        </div>
                    </div>
                </div>

                <div className="form-col-12">
                    <div className="flex flex-wrap gap-3 mt-4">
                        <button type="submit" className="db-btn py-2 text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                            <i className="lab lab-save"></i>
                            <span>save</span>
                            {isFormSumbmit ? (
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <></>
                            )}
                        </button>
                        <button type="button" className="modal-btn-outline modal-close" onClick={handleModelClose}>
                            <i className="lab lab-close"></i>
                            <span>close</span>
                        </button>
                    </div>
                </div>
            </form>
        </CommonModal>
    );
};

export default AddEditItemAddonModel;
